/**
 * Mapa de ícones Ant Design Vue (nome -> componente).
 * Usado no VueMenu para exibir o ícone do menu e em Menus.vue para a lista de opções.
 */
import * as AntIcons from '@ant-design/icons-vue'

const exclude = new Set(['createFromIconfontCN', 'default', 'setTwoToneColor', 'getTwoToneColor'])

export const antdIconsMap = Object.keys(AntIcons)
  .filter((key) => !exclude.has(key))
  .reduce((acc, key) => {
    acc[key] = AntIcons[key]
    return acc
  }, {})

/** Lista de nomes de ícones para uso em selects (ordenada) */
export const antdIconNames = Object.keys(antdIconsMap).sort()
